import React from "react";
import hotel from "../../imagenes/paquetes/ribbon/hotel.png";
import bus from "../../imagenes/paquetes/ribbon/bus.png";
import avion from "../../imagenes/paquetes/ribbon/avion.png";
import seguro from "../../imagenes/paquetes/ribbon/seguro.png";
import pension from "../../imagenes/paquetes/ribbon/pension.png";

const IconosServicios = ({ producto }) => {
  const { transporte, regimen, notaAlojamiento, seguroMedico, transfer } = producto;
  /*
  let iconoTransporte = "";

  if (producto.transporte.descripcion === "BUS")
    iconoTransporte = "directions_bus";

  if (producto.transporte.descripcion === "AER")
    iconoTransporte = "airplanemode_active";
  */
  const altTransporte =  transporte.descripcion + " - " + transporte.categoria;

  return (
    <div className="features">
      <ul>
        {regimen.descripcion !== "SIN REGIMEN" && (
          <li>
           <img src={pension} alt={regimen.descripcion} />
          </li>
        )}
        {transporte.descripcion !== "" && (
          <li>
            <img src={transporte.descripcion === "AER" ? avion : bus} alt={altTransporte} />
           
          </li>
        )}
        {notaAlojamiento !== "" && (
          <li>
            <img src={hotel} alt={notaAlojamiento} />
          </li>
        )}
        {seguroMedico !== "0" && (
          <li>
            <img src={seguro} alt="Asistencia al Viajero" />
          </li>
        )}
        {transfer !== "" && (
          <li>
             <img src={bus} alt={transfer} />
          </li>
        )}
      </ul>
    </div>
  );
};

export default IconosServicios;



// WEBPACK FOOTER //
// ./src/components/Global/IconosServicios.js